export function formatNumToDays (num) {
  return `${num} day${num !== 1 ? 's' : ''}`
}

export function formatNumToPrice (num) {
  return new Intl.NumberFormat(undefined, { style: 'decimal' }).format(num)
}

const TYPE_MAP = {
  time: formatNumToDays,
  amount: formatNumToPrice
}

export function format (type) {
  return TYPE_MAP[type]
}
